[
    {
        "key": "1",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 4,
                "y": 7,
                "key": "xMSu7"
            },
            {
                "x": 2,
                "y": 7,
                "key": "i1otH"
            },
            {
                "x": 2,
                "y": 2,
                "key": "UmGU9e9DGAW2cgtDM5LDE"
            },
            {
                "x": 14,
                "y": 2,
                "key": "m0tm9EaEvdCqJFffxHmqg"
            },
            {
                "x": 14,
                "y": 7,
                "key": "yISFx"
            },
            {
                "x": 12,
                "y": 7,
                "key": "U2EqybwO2xGhP4bxOgYGF"
            },
            {
                "x": 12,
                "y": 9,
                "key": "SNZ-8"
            },
            {
                "x": 4,
                "y": 9,
                "key": "tgAlOo15-hexJ72EDJs-g"
            }
        ]
    },
    {
        "key": "2",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 19,
                "y": 9,
                "key": "9rieT"
            },
            {
                "x": 19,
                "y": 4,
                "key": "c4Q6k"
            },
            {
                "x": 21,
                "y": 4,
                "key": "WmGhD"
            },
            {
                "x": 21,
                "y": 2,
                "key": "b4r5f"
            },
            {
                "x": 29,
                "y": 2,
                "key": "x71fa"
            },
            {
                "x": 29,
                "y": 4,
                "key": "aWLpt"
            },
            {
                "x": 31,
                "y": 4,
                "key": "2fMw5"
            },
            {
                "x": 31,
                "y": 9,
                "key": "xVV27"
            }
        ]
    },
    {
        "key": "3",
        "zoomout": 1,
        "z": 1,
        "points": [
            {
                "x": 36,
                "y": 2,
                "key": "Gh8Sd"
            },
            {
                "x": 48,
                "y": 2,
                "key": "gMMqn"
            },
            {
                "x": 48,
                "y": 9,
                "key": "0LVIF"
            },
            {
                "x": 36,
                "y": 9,
                "key": "EQUb8"
            }
        ]
    }
]